import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-baseline-overview',
  templateUrl: './baseline-overview.component.html',
  styleUrls: ['./baseline-overview.component.scss']
})
export class BaselineOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
